import { useFetch } from '@stashinvest/use-fetch';
import { getInstrumentationProperties } from './properties';
import { setStoredAttributions } from './storedAttributions';

const useSendAnalytics = (): {
	sendAnalyticData: (userUuid: string) => Promise<void>;
} => {
	const { fetch: instrumentationAddWebProperties } = useFetch({
		path: '/apis/customers/v1/analytics/web_properties',
		method: useFetch.POST,
	});

	const sendAnalyticData = async (userUuid: string): Promise<void> => {
		const addPropertiesBody = {
			userId: userUuid,
			properties: getInstrumentationProperties(),
		};

		instrumentationAddWebProperties({ body: addPropertiesBody });
		setStoredAttributions(addPropertiesBody.properties);
	};

	return { sendAnalyticData };
};

export default useSendAnalytics;
